import PropTypes from 'prop-types';

import { useIntl } from '@zenbusiness/application-commons-intl';

import Display from './Display';

const GoodStanding = ({ title = 'Order Details', taskData: { jurisdiction } = {}, onClose }) => {
  const { formatMessage: fm } = useIntl();

  const sections = [
    {
      title: fm({ id: 'orderView.items.orderJurisdiction' }),
      filter: !!jurisdiction,
      items: [{ content: jurisdiction, xs: 12 }],
    },
  ];

  return <Display onClose={onClose} sections={sections} title={title} />;
};

GoodStanding.propTypes = {
  title: PropTypes.string,
  taskData: PropTypes.shape({}).isRequired,
  onClose: PropTypes.func.isRequired,
};

export default GoodStanding;
